module.exports = __webpack_public_path__ + "img/grend_3.363af81d.jpg";